import React from 'react'
import { skeletonLoading } from '@/checkout-instore-legacy/components/Commons/ProductAvailabilityInfo/utils'

const SkeletonLoadingGrid = (key: any) => (
  <div className="mt6" key={key}>
    <div>{skeletonLoading}</div>
    <div>{skeletonLoading}</div>
    <div>{skeletonLoading}</div>
  </div>
)

const FiltersLoading = (): JSX.Element => {
  const loadingGroups = Array(4)
    .fill('')
    .map((_val, index) => <SkeletonLoadingGrid key={index} />)

  return <span data-testid="search-filters-loading">{loadingGroups}</span>
}

export default FiltersLoading
